import { render, staticRenderFns } from "./resetMail.vue?vue&type=template&id=bd49fc6c&"
import script from "./resetMail.vue?vue&type=script&lang=js&"
export * from "./resetMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports